import { useApiInspectionsV1CompaniesList } from 'api';

export const useAllInspectionCompanies = () => {
  return useApiInspectionsV1CompaniesList({
    is_active: true,
    page_size: 10000,
  });
};
